<ng-content></ng-content>
<button mat-icon-button (click)="toggleShowPassword($event)" *ngIf="showEye">
  <mat-icon [svgIcon]="showPassword ? 'eye-off' : 'eye-on'" />
</button>
